import _root_default from "./_root.js";

//#region ../../node_modules/lodash-es/_Symbol.js
/** Built-in value references. */
var Symbol = _root_default.Symbol;
var _Symbol_default = Symbol;

//#endregion
export { _Symbol_default as default };
//# sourceMappingURL=_Symbol.js.map